export default "__VITE_ASSET__D3ZcLwb7__"